import { call, put, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/applicants";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import history from "../../routes/History";

function* getApplicantsListSaga({ payload }) {
  try {
    yield put(
      actions.getApplicantsResponse({
        list: [],
        meta: {},
      })
    );
    const response = yield call(apis.getApplicantsList, payload);
    yield put(
      actions.getApplicantsResponse({
        list: response.data.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getApplicantsRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* getApplicantSaga({ payload }) {
  try {
    const response = yield call(apis.getApplicant, +payload.id);
    yield put(actions.getApplicantResponse(response.data.data));
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

function* updateApplicantSaga({ payload }) {
  const { onSuccess, ...requestPayload } = payload;
  try {
    const response = yield call(apis.updateApplicant, requestPayload);
    yield put(actions.getApplicantResponse(response.data.data));
    yield showSuccessMsg(
      payload?.params?.is_blocked
        ? "blockedSuccessfully"
        : "unBlockedSuccessfully"
    );
    if (typeof onSuccess === "function") {
      onSuccess(response.data.data);
    }
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

function* getAEligiblepplicantsListSaga({ payload }) {
  try {
    yield put(
      actions.getEligibleApplicantsResponse({
        list: [],
        meta: {},
      })
    );
    const response = yield call(apis.getEligibleApplicantsList, payload);
    yield put(
      actions.getEligibleApplicantsResponse({
        list: response.data.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getEligibleApplicantsRequest({
          ...payload,
          params: {
            ...payload.params,
            page: +response.headers["total-pages"],
          },
        })
      );
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* updateProfileSaga({ payload }) {
  try {
    const { portalVariant, ...requestPayload } = payload;
    const response = yield call(apis.updateApplicantProfile, requestPayload);
    yield put(actions.updateApplicantProfileResponse(response.data.data));
    yield showSuccessMsg(response.data.message, true);
    const viewPath =
      portalVariant === "company-portal"
        ? ROUTE_PATHS.companyViewApplicantProfile.replace(":id", payload.id)
        : ROUTE_PATHS.viewApplicant.replace(":id", payload.id);
    history.push(viewPath);
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

function* updateApplicantDeductionListSaga({ payload }) {
  try {
    const response = yield call(apis.updateApplicantDeduction, payload);
    yield put(actions.updateApplicantDeductionResponse(response.data.data));
    yield showSuccessMsg(response.data.message, true);
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

function* updateApplicantRewardListSaga({ payload }) {
  try {
    const response = yield call(apis.updateApplicantReward, payload);
    yield put(actions.updateApplicantRewardResponse(response.data.data));
    yield showSuccessMsg(response.data.message, true);
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

function* updateApplicantRevertRewardListSaga({ payload }) {
  try {
    const response = yield call(apis.updateApplicantRevertReward, payload);
    yield put(actions.updateApplicantRevertRewardResponse(response.data.data));
    yield showSuccessMsg(response.data.message, true);
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

function* updateApplicantRevertDeductionListSaga({ payload }) {
  try {
    const response = yield call(apis.updateApplicantRevertDeduction, payload);
    yield put(
      actions.updateApplicantRevertDeductionResponse(response.data.data)
    );
    yield showSuccessMsg(response.data.message, true);
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

function* promoteApplicantSaga({ payload }) {
  try {
    const response = yield call(apis.promoteApplicantRole, payload);
    yield put(actions.promoteApplicantResponse(response.data.data));
    yield showSuccessMsg(response?.data?.message, true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

function* demoteApplicantSaga({ payload }) {
  try {
    const response = yield call(apis.demoteApplicantRole, payload);
    yield put(actions.demoteApplicantResponse(response.data.data));
    yield showSuccessMsg(response?.data?.message, true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

function* getCheckListingApplicantsListSaga({ payload }) {
  try {
    const response = yield call(apis.getCheckListingApplicantsList, payload);
    const listingById = new Map(
      response.data.data.map((item) => [String(item.id), item])
    );
    const orderedListing = payload
      .map((id) => listingById.get(String(id)))
      .filter(Boolean);
    yield put(
      actions.getApplicantListingProfileResponse({
        listing: orderedListing,
      })
    );
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

export default function* ApplicantsSagas() {
  yield takeEvery(types.GET_APPLICANTS_REQUEST, getApplicantsListSaga);
  yield takeEvery(types.GET_APPLICANT_REQUEST, getApplicantSaga);
  yield takeEvery(types.UPDATE_APPLICANT, updateApplicantSaga);
  yield takeEvery(
    types.GET_ELIGIBLE_APPLICANTS_REQUEST,
    getAEligiblepplicantsListSaga
  );
  yield takeEvery(types.UPDATE_APPLICANT_REQUEST, updateProfileSaga);
  yield takeEvery(
    types.UPDATE_APPLICANT_DEDUCTION_REQUEST,
    updateApplicantDeductionListSaga
  );
  yield takeEvery(
    types.UPDATE_APPLICANT_REWARD_REQUEST,
    updateApplicantRewardListSaga
  );
  yield takeEvery(
    types.UPDATE_APPLICANT_REVERT_REWARD_REQUEST,
    updateApplicantRevertRewardListSaga
  );
  yield takeEvery(
    types.UPDATE_APPLICANT_REVERT_DEDUCTION_REQUEST,
    updateApplicantRevertDeductionListSaga
  );
  yield takeEvery(
    types.GET_CHECK_LISTING_PROFILE_REQUEST,
    getCheckListingApplicantsListSaga
  );
  yield takeEvery(types.PROMOTE_APPLICANT_REQUEST, promoteApplicantSaga);
  yield takeEvery(types.DEMOTE_APPLICANT_REQUEST, demoteApplicantSaga);
}
